<template>
    <div>
        <loading :active.sync="bool_fullLoading"></loading>
        <div v-if="bool_isAMV">
            <transition name="modal-fade">
                <div class="modal-backdrop" margin="auto">
                    <div class="popupWindow">
                        <CCard>
                            <CCardBody class="modal-body" id="modalDescription">
                                <CRow>
                                    <CCol col="8">
                                        <h4 id="traffic" class="card-title mb-0">{{checkModuleIndex('CPR', 'R', constAccessType.view, '', -1)}} {{ this.getLanguage["BTN"]["AN"] }}</h4>
                                    </CCol>
                                    <CCol col="4">
                                        <CButton id="btn-close1" class="float-right" @click="closeAdd">
                                            <CIcon name="cilX"></CIcon>
                                        </CButton>
                                    </CCol>
                                </CRow>
                                <div class='subHeaderHR'></div>
                                <div class="modal-main-content">
                                    <CRow>
                                        <CCol col="6" class="form-group">
                                            <div>
                                                <label class="col-form-label-sm">{{ getLanguage["CPR"]["EDT"] }} :</label>
                                                <input type="text" readonly v-model="obj_ab.ED">
                                            </div>
                                        </CCol>
                                        <CCol col="6" class="form-group">
                                            <label class="col-form-label-sm">{{ getLanguage["CPR"]["ET"] }} :</label>
                                            <vue-timepicker format="HH:mm:ss" v-model="obj_ab.ET"></vue-timepicker>
                                        </CCol>
                                    </CRow>
                                    <CRow>
                                        <CCol col="6">
                                            <label class="col-form-label-sm"> {{getLanguage["MDB"]["BN"]}}<span class="required" /> :</label>
                                            <treeselect :multiple="false"
                                                        :options="dd_bank"
                                                        v-model="obj_ab.BID"
                                                        @input="BankNameChange"
                                                        :placeholder="this.utilGetDDLanguage('MDB.BN')"
                                                        :load-options="getBankName"
                                                        :clearable="false" />
                                            <span class="ErrMsg">{{ ValidationErrMsg('BID','BN') }}</span>
                                        </CCol>
                                        <CCol col="6">
                                            <label class="col-form-label-sm"> {{getLanguage["MDB"]["BAN"]}}<span class="required" /> :</label>
                                            <treeselect :multiple="false"
                                                        :options="dd_bankacc"
                                                        :placeholder="this.utilGetDDLanguage('MDB.BAN')"
                                                        :noOptionsText="this.getLanguage['GL']['NOA']"
                                                        v-model="obj_ab.BAID"
                                                        @input="BankAccountChange"
                                                        :clearable="false" />
                                            <span class="ErrMsg">{{ ValidationErrMsg('BAID','BAN') }}</span>
                                        </CCol>
                                    </CRow>
                                    <CRow>
                                        <CCol col="6" class="form-group">
                                            <label class="col-form-label-sm">{{ getLanguage["CPR"]["TFI"] }}<span class="required" /> :</label>
                                            <CInput :prepend="CurrencySymbol"
                                                    size="sm"
                                                    :value="ThousandSeparator(obj_ab.TI, 2)"
                                                    @change="v => obj_ab.TI = RemoveThousandSeparator(v, 2)" />
                                            <span class="ErrMsg">{{ ValidationErrMsg('TI','TFI') }}</span>
                                        </CCol>
                                        <CCol col="6" class="form-group">
                                            <label class="col-form-label-sm">{{ getLanguage["CPR"]["TFO"] }}<span class="required" /> :</label>
                                            <CInput :prepend="CurrencySymbol"
                                                    size="sm"
                                                    :value="ThousandSeparator(obj_ab.TO, 2)"
                                                    @change="v => obj_ab.TO = RemoveThousandSeparator(v, 2)" />
                                            <span class="ErrMsg">{{ ValidationErrMsg('TO','TFO') }}</span>
                                        </CCol>
                                    </CRow>
                                    <CRow>
                                        <CCol col="6" row="2" class="form-group">
                                            <label class="col-form-label-sm">{{ this.getLanguage["CPR"]["S"] }}<span class="required" /> :</label>
                                            <CInput :prepend="CurrencySymbol"
                                                    size="sm"
                                                    :value="ThousandSeparator(obj_ab.SF, 2)"
                                                    @change="v => obj_ab.SF = RemoveThousandSeparator(v, 2)" />
                                            <span class="ErrMsg">{{ ValidationErrMsg('SF','S') }}</span>
                                        </CCol>
                                        <CCol col="6">
                                            <label class="col-form-label-sm">{{ this.getLanguage["PM"]["RM"] }}:</label>
                                            <textarea class="form-control form-control-sm" vertical="" rows="4" v-model="obj_ab.R"></textarea>
                                        </CCol>
                                    </CRow>
                                </div>
                                <div style="text-align:center;margin-top:20px">
                                    <CButton color="outline-info" size="sm" @click="saveRecord()">
                                        <span class='plusIcon cil-plus'></span>
                                        {{ this.getLanguage["BTN"]["SV"] }}
                                    </CButton>
                                </div>
                                <label class="mandatory_Field">{{ this.getLanguage['MANDATORY']['FIELDS'] }}</label>
                            </CCardBody>
                        </CCard>
                    </div>
                </div>
            </transition>
        </div>

        <div class="container-fluid">
            <CRow>
                <CCol>
                    <div class='pageHeader'>
                        <h2 id="titleHeight">{{checkModuleIndex('CPR', 'R', constAccessType.view, '', -1)}} {{this.getLanguage["CPR"]["CPRD"]}}</h2>
                        <CButton v-if="(!isSignOff || this.getUserInfo.AT == 0) && (checkModuleAccess2(constAccessType.add))"
                                 size="sm"
                                 color="outline-info"
                                 @click="addRecord()"
                                 data-toggle="notificationAddmodal"
                                 data-target="#myModal">
                            <span class="plusIcon cil-plus"></span>
                            {{ this.getLanguage["BTN"]["AN"] }}
                        </CButton>
                        <button @click="refreshThisPage();" id="refreshButtonID" type="button" class="btn btn-outline-primary btn-sm text-center">
                            <span class="plusIcon cil-reload"></span>
                            {{ this.getLanguage["CPR"]["RF"] }}
                        </button>
                        <div class="searchBox"></div>
                        <button @click="ShowDetails();" id="hide-seen" type="button" class="btn btn-outline-primary btn-sm">
                            {{button.text}}
                        </button>
                    </div>
                </CCol>
            </CRow>

            <template v-if="this.bool_showDetails">
                <div class='table-wrapper'>
                    <div class="custom-table-wrapper">
                        <table class='custom-table custom-tableMP afb-blue'>
                            <thead>
                                <tr>
                                    <th style="width:180px">{{ getLanguage["CPR"]["BD"] }}</th>
                                    <th class="text-center">{{ getLanguage["MEM"]["CI"] }}</th>
                                    <th class="tableCtnRight">{{ getLanguage["CPR"]["OPENING"] }}</th>
                                    <th class="tableCtnRight">{{ getLanguage["BB"]["D"] }}</th>
                                    <th class="tableCtnRight">{{ getLanguage["BB"]["W"] }}</th>
                                    <th class="tableCtnRight">{{ getLanguage["CPR"]["TFI"] }}</th>
                                    <th class="tableCtnRight">{{ getLanguage["CPR"]["TFO"] }}</th>
                                    <th class="tableCtnRight">{{ getLanguage["CPR"]["S"] }}</th>
                                    <th class="tableCtnRight">{{ getLanguage["CPR"]["CLOSING"] }}</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr v-if="!arr_CashPositionBankSummaryList || arr_CashPositionBankSummaryList.length == 0">
                                    <td colspan="100%" class="tableCtnCenter">{{ this.getLanguage['GL']['NR'] }}</td>
                                </tr>
                                <tr v-else v-for="(data,index) in arr_CashPositionBankSummaryList">
                                    <td>
                                        <div class="custom_tooltip">
                                            <span v-if="(data.BN != null && data.BAN !== null) ">
                                                {{ formatBankName(data.BN,data.BAN) }}{{data.BAN}}
                                            </span>
                                            <span v-else-if="( data.BAN != null && data.BAN.length > 15 )">
                                                {{ formatBankName(data.BN,data.BAN) }}{{ formatString(data.BAN,15) }}
                                                <span class="tooltiptext2">{{ formatBankName(data.BN,data.BAN) }}{{data.BAN}}</span>
                                            </span>
                                            <span v-else>
                                                {{ data.PMN }}
                                            </span>
                                        </div>
                                    </td>
                                    <td class="text-center">
                                        {{ data.ISOC }}
                                    </td>
                                    <td class="tableCtnRight">
                                        <span v-if="data.OA !== 0">
                                            <span v-if="!checkWholeNumber(data.OA)" :class="data.OA >= 0? 'positive-number': 'negative-number'">
                                                {{ formatNumber(data.OA, 0) }}
                                            </span>
                                            <span v-else :class="data.OA >= 0? 'positive-number': 'negative-number'">
                                                {{ formatNumber(data.OA, 2) }}
                                            </span>
                                        </span>
                                    </td>
                                    <td class="tableCtnRight">
                                        <span v-if="data.DA !== 0">
                                            <span v-if="!checkWholeNumber(data.DA)" :class="data.DA >= 0? 'positive-number': 'negative-number'">
                                                {{ formatNumber(data.DA, 0) }}
                                            </span>
                                            <span v-else :class="data.DA >= 0? 'positive-number': 'negative-number'">
                                                {{ formatNumber(data.DA, 2) }}
                                            </span>
                                        </span>
                                    </td>
                                    <td class="tableCtnRight">
                                        <span v-if="data.WA !== 0">
                                            <span v-if="!checkWholeNumber(data.WA)" class="negative-number">
                                                {{ formatNumber(data.WA, 0) }}
                                            </span>
                                            <span v-else class="negative-number">
                                                {{ formatNumber(data.WA, 2) }}
                                            </span>
                                        </span>
                                    </td>
                                    <td class="tableCtnRight">
                                        <span v-if="data.TI !== 0">
                                            <span v-if="!checkWholeNumber(data.TI)" class="positive-number">
                                                {{ formatNumber(data.TI, 0) }}
                                            </span>
                                            <span v-else class="positive-number">
                                                {{ formatNumber(data.TI, 2) }}
                                            </span>
                                        </span>
                                    </td>
                                    <td class="tableCtnRight">
                                        <span v-if="data.TO !== 0">
                                            <span v-if="!checkWholeNumber(data.TO)" class="negative-number">
                                                {{ formatNumber(data.TO, 0) }}
                                            </span>
                                            <span v-else class="negative-number">
                                                {{ formatNumber(data.TO, 2) }}
                                            </span>
                                        </span>
                                    </td>
                                    <td class="tableCtnRight">
                                        <span v-if="data.SF !== 0">
                                            <span v-if="!checkWholeNumber(data.SF)" class="negative-number">
                                                {{ formatNumber(data.SF, 0) }}
                                            </span>
                                            <span v-else class="negative-number">
                                                {{ formatNumber(data.SF, 2) }}
                                            </span>
                                        </span>
                                    </td>
                                    <td class="tableCtnRight">
                                        <span v-if="data.CA !== 0">
                                            <span v-if="!checkWholeNumber(data.CA)" :class="data.CA>=0?'positive-number':'negative-number'">
                                                {{ formatNumber(data.CA, 0) }}
                                            </span>
                                            <span v-else :class="data.CA>=0?'positive-number':'negative-number'">
                                                {{ formatNumber(data.CA, 2) }}
                                            </span>
                                        </span>
                                    </td>
                                    <!--<td class="tableCtnRight">
        <span v-if="(data.OA + data.DA - data.WA + data.TI - data.TO - data.SF) !== 0">
            <span v-if="!checkWholeNumber(data.OA + data.DA - data.WA + data.TI - data.TO - data.SF)" :class="(data.OA + data.DA - data.WA + data.TI - data.TO + data.SF) > 0? 'positive-number': 'negative-number'">
                {{ //formatNumber((data.OA + data.DA - data.WA + data.TI - data.TO - data.SF), 0) }}
            </span>
            <span v-else :class="(data.OA + data.DA - data.WA + data.TI - data.TO - data.SF) > 0? 'positive-number': 'negative-number'">
                {{ //formatNumber((data.OA + data.DA - data.WA + data.TI - data.TO - data.SF), 2) }}
            </span>
        </span>&nbsp;
    </td>-->
                                </tr>
                                <tr v-if="CashPositionBankTotal.CS" class="cp-sticky afb-blue tableCtnRight">
                                    <td class="cp-white">{{ getLanguage["CPR"]["TOTAL"] }}</td>
                                    <td class="cp-white text-center">{{ CashPositionBankTotal.CS }}</td>
                                    <td :class="CashPositionBankTotal.OA >= 0? 'cp-positive': 'cp-negative'">
                                        {{ formatNumber(CashPositionBankTotal.OA, 2) }}
                                    </td>
                                    <td :class="CashPositionBankTotal.DA >= 0? 'cp-positive': 'cp-negative'">
                                        {{ formatNumber(CashPositionBankTotal.DA, 2) }}
                                    </td>
                                    <td :class="CashPositionBankTotal.WA >= 0? 'cp-positive': 'cp-negative'">
                                        {{ formatNumber(CashPositionBankTotal.WA, 2) }}
                                    </td>
                                    <td :class="CashPositionBankTotal.TI >= 0? 'cp-positive': 'cp-negative'">
                                        {{ formatNumber(CashPositionBankTotal.TI, 2) }}
                                    </td>
                                    <td class="cp-negative">
                                        {{ formatNumber(CashPositionBankTotal.TO, 2) }}
                                    </td>
                                    <td class="cp-negative">
                                        {{ formatNumber(CashPositionBankTotal.SF, 2) }}
                                    </td>
                                    <td :class="CashPositionBankTotal.CA >= 0? 'cp-positive': 'cp-negative'">
                                        {{ formatNumber(CashPositionBankTotal.CA, 2) }}
                                    </td>
                                    <!--<td >
        <span v-if="SummaryTotalOAAmount !== 0">
            <span v-if="!checkWholeNumber(SummaryTotalOAAmount)" :class="SummaryTotalOAAmount > 0? 'cp-positive': 'cp-negative'">
                {{ //formatNumber(SummaryTotalOAAmount, 0) }}
            </span>
            <span v-else :class="SummaryTotalOAAmount > 0? 'cp-positive': 'cp-negative'">
                {{ //formatNumber(SummaryTotalOAAmount, 2) }}
            </span>
        </span>&nbsp;
    </td>-->
                                    <!--<td>
        <span v-if="SummaryTotalDepositAmount !== 0">
            <span v-if="!checkWholeNumber(SummaryTotalDepositAmount)" class="cp-positive">
                {{ //formatNumber(SummaryTotalDepositAmount, 0) }}
            </span>
            <span v-else class="cp-positive">
                {{ //formatNumber(SummaryTotalDepositAmount, 2) }}
            </span>
        </span>&nbsp;
    </td>
    <td>
        <span v-if="SummaryTotalWithDrawAmount !== 0">
            <span v-if="!checkWholeNumber(SummaryTotalWithDrawAmount)" class="negative-number">
                {{ //formatNumber(SummaryTotalWithDrawAmount, 0) }}
            </span>
            <span v-else class="negative-number">
                {{ //formatNumber(SummaryTotalWithDrawAmount, 2) }}
            </span>
        </span>&nbsp;
    </td>
    <td>
        <span v-if="SummaryTotalTIAmount !== 0">
            <span v-if="!checkWholeNumber(SummaryTotalTIAmount)" class="cp-positive">
                {{ //formatNumber(SummaryTotalTIAmount, 0) }}
            </span>
            <span v-else class="cp-positive">
                {{ //formatNumber(SummaryTotalTIAmount, 2) }}
            </span>
        </span>&nbsp;
    </td>
    <td>
        <span v-if="SummaryTotalTOAmount !== 0">
            <span v-if="!checkWholeNumber(SummaryTotalTOAmount)" class="cp-negative">
                {{ //formatNumber(SummaryTotalTOAmount, 0) }}
            </span>
            <span v-else class="cp-negative">
                {{ //formatNumber(SummaryTotalTOAmount, 2) }}
            </span>
        </span>&nbsp;
    </td>
    <td>
        <span v-if="SummaryTotalSFAmount !== 0">
            <span v-if="!checkWholeNumber(SummaryTotalSFAmount)" class="cp-negative">
                {{ //formatNumber(SummaryTotalSFAmount, 0) }}
            </span>
            <span v-else class="cp-negative">
                {{ //formatNumber(SummaryTotalSFAmount, 2) }}
            </span>
        </span>&nbsp;
    </td>
    <td>
        <span v-if="SummaryTotalCAAmount !== 0">
            <span v-if="!checkWholeNumber(SummaryTotalCAAmount)" :class="SummaryTotalCAAmount > 0? 'cp-positive': 'cp-negative'">
                {{ //formatNumber(SummaryTotalCAAmount, 0) }}
            </span>
            <span v-else :class="SummaryTotalCAAmount > 0? 'cp-positive': 'cp-negative'">
                {{ //formatNumber(SummaryTotalCAAmount, 2) }}
            </span>
        </span>&nbsp;
    </td>-->
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </div>
            </template>
            <div class="table-wrapper with_page">
                <header class="table-header">
                    <div>
                        <strong>{{ getLanguage["CPR"]["DD"] }}&nbsp;{{ GroupNamePC }} : {{ formatDateTime(this.rDate, "YYYY-MM-DD", "DD MMM YYYY") }}</strong>&nbsp;&nbsp;
                        <CButton v-if="!isSignOff || this.getUserInfo.AT == 0" color="outline-primary" size="sm" @click="SignOff()"><span class='plusIcon cil-lock-locked'></span>{{this.getLanguage["FR"]["SOFF"]}}</CButton>
                        <span v-else v-html="lastSignOffDate" class="cp-negative isItalic"></span>
                    </div>
                    <div class="pageBtn">
                        <div>
                            <CButton v-if="checkModuleAccess2(constAccessType.edit)" class="btnExcel" @click="saveToExcel()">
                                <img src="/Content/img/excel.png" width="20" style="padding-left:2px">
                                {{this.getLanguage["BTN"]["DL"]}}
                            </CButton>
                        </div>
                        <button @click="ctrPage(+int_Page - 1)">
                            <span class="arrowLeft"></span>
                        </button>
                        <input class="page-control"
                               v-model="int_Page"
                               type="number"
                               v-shortkey.avoid
                               @keyup="ctrPage(+int_Page,0)" />
                        <span class="tableItemCount">/ {{ int_TP }}</span>
                        <button @click="ctrPage(+int_Page + 1)">
                            <span class="arrowRight"></span>
                        </button>
                    </div>
                </header>

                <div class="custom-table-wrapper">

                    <table class='custom-table afb-blue'>
                        <thead>
                            <tr>
                                <th v-if="(!isSignOff) && ( checkModuleAccess2(constAccessType.edit) || checkModuleAccess2(constAccessType.delete) || checkModuleAccess2(constAccessType.view) )">{{getLanguage["GL"]["ACT"]}}</th>
                                <th>{{ getLanguage["GL"]["NO"] }}</th>
                                <th>{{ getLanguage["CPR"]["TIME"] }}</th>
                                <th>{{ getLanguage["MEM"]["U"] }}</th>
                                <th>{{ getLanguage["CPR"]["BANK"] }}</th><!--bank-->
                                <th class="text-center">{{ getLanguage['MEM']['CI']}}</th><!--currency-->
                                <th class="tableCtnRight">{{ getLanguage["BB"]["D"] }}</th><!--deposit-->
                                <th class="tableCtnRight">{{ getLanguage["BB"]["W"] }}</th><!--withdraw-->
                                <th class="tableCtnRight">{{ getLanguage["CPR"]["TFI"] }}</th>
                                <th class="tableCtnRight">{{ getLanguage["CPR"]["TFO"] }}</th>
                                <th>{{ getLanguage["CPR"]["S"] }}</th>
                                <th>{{ getLanguage["BA"]["R"] }}</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr v-if="!arr_CashPositionReportDetailList || arr_CashPositionReportDetailList.length == 0">
                                <td colspan="100%">{{ this.getLanguage['GL']['NR'] }}</td>
                            </tr>
                            <tr v-else v-for="(data,index) in arr_CashPositionReportDetailList">
                                <td class="tableCtnCenter" v-if="(!isSignOff) && ( checkModuleAccess2(constAccessType.edit) || checkModuleAccess2(constAccessType.delete) || checkModuleAccess2(constAccessType.view) )">
                                    <span v-if="checkTransID(data.TID, data.RS)" class="custom_tooltip">
                                        <i class="cil-trash" @click="removeManualEntries(data)"></i>
                                        <span class="tooltiptext">{{getLanguage["BTN"]["DLT"]}}</span>
                                    </span>
                                </td>
                                <td>{{ CountItem(index+1) }}</td>
                                <td>{{ formatTime(data.TU) }}</td>
                                <td>{{ data.M }}</td>
                                <td>
                                    <span v-if="(data.BN != null && data.BAN !== null) ">
                                        {{renderBank(data.BN)}}{{ data.BAN }}
                                    </span>
                                    <span v-else>
                                        {{ data.PMN }}
                                    </span>
                                </td>
                                <td class="text-center" v-if="(data.ISOC != null && data.ISOC != '') ">{{ data.ISOC }}</td>
                                <td class="text-center" v-else>{{ DefaultCurrency }}</td>
                                <td class="tableCtnRight">
                                    <span v-if="data.TT === 1">
                                        <span v-if="data.TA !== 0">
                                            <span v-if="!checkWholeNumber(data.TA)" :class="data.TA > 0? 'positive-number': 'negative-number'">
                                                {{ formatNumber(data.TA, 0) }}
                                            </span>
                                            <span v-else :class="data.TA > 0? 'positive-number': 'negative-number'">
                                                {{ formatNumber(data.TA, 2) }}
                                            </span>
                                        </span>
                                    </span>
                                </td>
                                <td class="tableCtnRight negative-number">
                                    <span v-if="data.TT === 2">
                                        <span v-if="data.TA !== 0">
                                            <span v-if="!checkWholeNumber(data.TA)" class="negative-number">
                                                {{ formatNumber(data.TA, 0) }}
                                            </span>
                                            <span v-else class="negative-number">
                                                {{ formatNumber(data.TA, 2) }}
                                            </span>
                                        </span>
                                    </span>
                                </td>
                                <td class="tableCtnRight">
                                    <span v-if="data.TI !== 0">
                                        <span v-if="!checkWholeNumber(data.TI)" class="positive-number">
                                            {{ formatNumber(data.TI, 0) }}
                                        </span>
                                        <span v-else class="positive-number">
                                            {{ formatNumber(data.TI, 2) }}
                                        </span>
                                    </span>
                                </td>
                                <td class="tableCtnRight">
                                    <span v-if="data.TO !== 0">
                                        <span v-if="!checkWholeNumber(data.TO)" class="negative-number">
                                            {{ formatNumber(data.TO, 0) }}
                                        </span>
                                        <span v-else class="negative-number">
                                            {{ formatNumber(data.TO, 2) }}
                                        </span>
                                    </span>
                                </td>
                                <td class="tableCtnRight">
                                    <span v-if="data.SF !== 0">
                                        <span v-if="!checkWholeNumber(data.SF)" class="cp-negative">
                                            {{ formatNumber(data.SF, 0) }}
                                        </span>
                                        <span v-else class="cp-negative">
                                            {{ formatNumber(data.SF, 2) }}
                                        </span>
                                    </span>
                                </td>
                                <td>
                                    <div class="custom_tooltip" style="float:left">
                                        <span v-if="( data.CPRR != null && data.CPRR.length > 30 )">
                                            {{ formatString(data.CPRR,30) }}
                                            <span class="tooltiptext2">{{data.CPRR}}</span>
                                        </span>
                                        <span v-else>
                                            {{ data.CPRR }}
                                        </span>
                                    </div>
                                </td>
                            </tr>
                            <tr v-if="CashPositionReportDetail && CashPositionReportDetail.CS != null" class="cp-sticky afb-blue tableCtnRight">
                                <td v-if="(!isSignOff) && ( checkModuleAccess2(constAccessType.edit) || checkModuleAccess2(constAccessType.delete) || checkModuleAccess2(constAccessType.view) )" colspan="5" class="cp-white">{{ getLanguage["CPR"]["TOTAL"] }}</td>
                                <td v-else colspan="4" class="cp-white">{{ getLanguage["CPR"]["TOTAL"] }}</td>
                                <td class="cp-white text-center">{{CashPositionReportDetail.CS}}</td>
                                <td :class="CashPositionReportDetail.DA >= 0? 'cp-positive': 'cp-negative'">
                                    {{ formatNumber(CashPositionReportDetail.DA, 2) }}
                                </td>                                
                                <td :class="CashPositionReportDetail.WA >= 0? 'cp-positive': 'cp-negative'">
                                    {{ formatNumber(CashPositionReportDetail.WA, 2) }}
                                </td>
                                <td :class="CashPositionReportDetail.TI >= 0? 'cp-positive': 'cp-negative'">
                                    {{ formatNumber(CashPositionReportDetail.TI, 2) }}
                                </td>
                                <td class="cp-negative">
                                    {{ formatNumber(CashPositionReportDetail.TO, 2) }}
                                </td>
                                <td class="cp-negative">
                                    {{ formatNumber(CashPositionReportDetail.SF, 2) }}
                                </td>
                                <td :class="CashPositionReportDetail.CA >= 0? 'cp-positive': 'cp-negative'">
                                    {{ formatNumber(CashPositionReportDetail.CA, 2) }}
                                </td>
                                <!--<td>
        <span v-if="totalDepositAmount !== 0">
            <span v-if="!checkWholeNumber(totalDepositAmount)" class="cp-positive">
                {{ //formatNumber(totalDepositAmount, 0) }}
            </span>
            <span v-else class="cp-positive">
                {{ //formatNumber(totalDepositAmount, 2) }}
            </span>
        </span>
    </td>
    <td>
        <span v-if="totalPromoAmount !== 0">
            <span v-if="!checkWholeNumber(totalPromoAmount)" class="cp-positive">
                {{ //formatNumber(totalPromoAmount, 0) }}
            </span>
            <span v-else class="cp-positive">
                {{ //formatNumber(totalPromoAmount, 2) }}
            </span>
        </span>
    </td>
    <td>
        <span v-if="totalWithDrawAmount !== 0">
            <span v-if="!checkWholeNumber(totalWithDrawAmount)" class="negative-number">
                {{ //formatNumber(totalWithDrawAmount, 0) }}
            </span>
            <span v-else class="negative-number">
                {{ //formatNumber(totalWithDrawAmount, 2) }}
            </span>
        </span>
    </td>
    <td>
        <span v-if="totalTransInAmount !== 0">
            <span v-if="!checkWholeNumber(totalTransInAmount)" class="cp-positive">
                {{ //formatNumber(totalTransInAmount, 0) }}
            </span>
            <span v-else class="cp-positive">
                {{ //formatNumber(totalTransInAmount, 2) }}
            </span>
        </span>
    </td>
    <td>
        <span v-if="totalTransOutAmount !== 0">
            <span v-if="!checkWholeNumber(totalTransOutAmount)" class="cp-negative">
                {{ //formatNumber(totalTransOutAmount, 0) }}
            </span>
            <span v-else class="cp-negative">
                {{ //formatNumber(totalTransOutAmount, 2) }}
            </span>
        </span>
    </td>
    <td>
        <span v-if="totalServiceAmount !== 0">
            <span v-if="!checkWholeNumber(totalServiceAmount)" class="cp-negative">
                {{ //formatNumber(totalServiceAmount, 0) }}
            </span>
            <span v-else class="cp-negative">
                {{ //formatNumber(totalServiceAmount, 2) }}
            </span>
        </span>
    </td>
    <td class="tableCtnCenter">
        <span v-if="!checkWholeNumber(totalDayAmount)" :class="totalDayAmount > 0? 'cp-positive': 'cp-negative'">
            {{ //formatNumber(totalDayAmount, 0) }}
        </span>
        <span v-else :class="totalDayAmount > 0? 'cp-positive': 'cp-negative'">
            {{ //formatNumber(totalDayAmount, 2) }}
        </span>
    </td>-->
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import { required, numeric, decimal, requiredIf } from "vuelidate/lib/validators";
    import { constAccessType, constRequestStatus } from '@/modules/Constant.js';
    import 'vue2-daterange-picker/dist/vue2-daterange-picker.css';
    import Treeselect from '@riophae/vue-treeselect';
    import '@riophae/vue-treeselect/dist/vue-treeselect.css';
    import Loading from 'vue-loading-overlay';
    import 'vue-loading-overlay/dist/vue-loading.css';
    import { mapGetters, mapActions } from 'vuex'
    import genericHelper from "@/modules/GenericHelper.js";
    import moment from "moment";
    import VueTimepicker from 'vue2-timepicker';
    import 'vue2-timepicker/dist/VueTimepicker.css';
    import Vue from 'vue';
    // const myDecimal = (value) => !isNaN(value)
    export default {
        mixins: [genericHelper],
        components: {
            VueTimepicker,
            Treeselect,
            Loading
        },
        data() {
            return {
                //   str_showDetails: "",
                bool_showDetails: false,
                agi: this.$route.query.agi,
                rDate: this.$route.query.rDate,
                int_RC: 100, //Row Count
                int_Total: 0,
                int_Page: 1,
                int_IC: 1, // Item Count
                int_TP: 1, //Total Page
                str_tableSortBy: "CTS", //(sort the table col name)
                bool_isSort: false, // Table Ascending Descending
                bool_fullLoading: false,
                bool_showSummary: true,
                bool_isAMV: false,
                bool_CV: false,
                arr_CashPositionReportDetailList: [],
                arr_CashPositionBankSummaryList: [],
                CashPositionBankTotal: null,
                CashPositionReportDetail: null,
                str_bankacc_used_agi: this.$route.query.agi, // 242
                dd_bank: [],//bank option
                dd_bankacc: [],
                button: {
                    text: "",
                },
                seen: false,
                constAccessType: constAccessType,
                // EntryDate: this.getTodayDate(),
                /// EntryTime: moment(new Date()).format('HH:mm'),
                obj_ab: {
                    // ED: null,
                    // ED: new Date().toISOString().slice(0, 10),
                    //   ED: this.getTodayDate(),
                    //   ET: moment(new Date()).format('HH:mm'),
                    ED: null,
                    ET: null,
                    I: 0,
                    CTS: "0001-01-01T00:00:00",
                    CBI: 0,
                    CB: null,
                    UTS: "0001-01-01T00:00:00",
                    UBI: 0,
                    UB: null,
                    AGI: this.agi,
                    TI: 0,
                    TO: 0,
                    SF: 0,
                    R: null,
                    LEDT: null,
                    BN: null,
                    BID: null,
                    BI: null,
                    BA: null,
                    BAN: null,
                    BAID: null
                },
                isSignOff: false,
                lastSignOffDate: '',
                CurrencySymbol: ''
            }
        },
        validations: {
            obj_ab: {
                BID: { required },
                BAID: { required },
                TI: {
                    decimal,
                    required: requiredIf(function (vm) {
                        return ((!this.obj_ab.TO || this.obj_ab.TO == 0) && (!this.obj_ab.SF || this.obj_ab.SF == 0)) ? true : false
                    }),
                },
                TO: {
                    decimal,
                    required: requiredIf(function (vm) {
                        return ((!this.obj_ab.TI || this.obj_ab.TI == 0) && (!this.obj_ab.SF || this.obj_ab.SF == 0)) ? true : false
                    }),
                },
                SF: {
                    decimal,
                    required: requiredIf(function (vm) {
                        return ((!this.obj_ab.TI || this.obj_ab.TI == 0) && (!this.obj_ab.TO || this.obj_ab.TO == 0)) ? true : false
                    }),
                },
            }
        },
        computed: {
            ...mapGetters("Language", ["getLanguage"]),
            ...mapGetters('UserInfo', ['getUserInfo', 'checkModuleAccess', 'checkModuleIndex']),
            ...mapGetters('CurrencyInfo', ['getThousandCurrency']),
            GroupNamePC: function () {
                var agnPC = null;
                if (!this.arr_CashPositionReportDetailList || this.arr_CashPositionReportDetailList.length <= 0) {
                    return agnPC;
                }
                else {
                    agnPC = this.arr_CashPositionReportDetailList[0].GN + " (" + this.arr_CashPositionReportDetailList[0].PC + " )";
                    return agnPC;
                }
            },
            //isSignOff: function () {
            //    var formatHTML = false;
            //    console.log(this.arr_CashPositionBankSummaryList);
            //    if (this.arr_CashPositionBankSummaryList.length > 0) {
            //        var arrayLength = this.arr_CashPositionBankSummaryList.length;
            //        for (let i = 0; i < arrayLength; i++) {
            //            if ( (this.arr_CashPositionBankSummaryList[i].I == 0) && (this.arr_CashPositionBankSummaryList[i].BAN !="H2P") ){
            //                var utsLable = moment(this.arr_CashPositionBankSummaryList[0].UTS).format('DD MMM YYYY hh:mm:ss')
            //                return formatHTML = "Signed Off at " + utsLable + "";
            //            }
            //            else {
            //                return false;
            //            }
            //        }
            //    }
            //},
            //SummaryTotalOAAmount: function () {
            //    var sum = 0;
            //    this.arr_CashPositionBankSummaryList.forEach(e => {
            //        sum += e.OA;
            //    });
            //    return sum;
            //},
            //SummaryTotalDepositAmount: function () {
            //    var sum = 0;
            //    this.arr_CashPositionBankSummaryList.forEach(e => {
            //        sum += e.DA;
            //    });
            //    return sum;
            //},
            //SummaryTotalWithDrawAmount: function () {
            //    var sum = 0;
            //    this.arr_CashPositionBankSummaryList.forEach(e => {
            //        sum += e.WA;
            //    });
            //    return sum;
            //},
            //SummaryTotalTIAmount: function () {
            //    var sum = 0;
            //    this.arr_CashPositionBankSummaryList.forEach(e => {
            //        sum += e.TI;
            //    });
            //    return sum;
            //},
            //SummaryTotalTOAmount: function () {
            //    var sum = 0;
            //    this.arr_CashPositionBankSummaryList.forEach(e => {
            //        sum += e.TO;
            //    });
            //    return sum;
            //},
            //SummaryTotalSFAmount: function () {
            //    var sum = 0;
            //    this.arr_CashPositionBankSummaryList.forEach(e => {
            //        sum += e.SF;
            //    });
            //    return sum;
            //},
            //SummaryTotalCAAmount: function () {
            //    var sum = 0;
            //    this.arr_CashPositionBankSummaryList.forEach(e => {
            //        sum += (e.OA + e.DA - e.WA + e.TI - e.TO - e.SF);
            //    });
            //    return sum;
            //},
            //DefaultCurrency: function () {
            //    var ISOC = null;
            //    if (this.arr_CashPositionReportDetailList && this.arr_CashPositionReportDetailList.length > 0) {
            //        var arrayLength = this.arr_CashPositionReportDetailList.length;
            //        for (let i = 0; i < arrayLength; i++) {
            //            if (this.arr_CashPositionReportDetailList[i].ISOC != null) {
            //                return this.arr_CashPositionReportDetailList[i].ISOC;
            //            }
            //        }
            //    }
            //    return ISOC;
            //},
            //totalDepositAmount: function () {
            //    var sum = 0;
            //    if (this.arr_CashPositionReportDetailList) {
            //        this.arr_CashPositionReportDetailList.forEach(e => {
            //            if (e.TT == 1) {
            //                sum += e.TA;
            //            }
            //        });
            //    }
            //    return sum;
            //},
            //totalPromoAmount: function () {
            //    var sum = 0;
            //    if (this.arr_CashPositionReportDetailList) {
            //        this.arr_CashPositionReportDetailList.forEach(e => {
            //            sum += e.P;
            //        });
            //    }
            //    return sum;
            //},
            //totalWithDrawAmount: function () {
            //    var sum = 0;
            //    if (this.arr_CashPositionReportDetailList) {
            //        this.arr_CashPositionReportDetailList.forEach(e => {
            //            if (e.TT == 2) {
            //                sum += e.TA;
            //            }
            //        });
            //    }
            //    return sum;
            //},
            //totalTransInAmount: function () {
            //    var sum = 0;
            //    if (this.arr_CashPositionReportDetailList) {
            //        this.arr_CashPositionReportDetailList.forEach(e => {
            //            sum += e.TI;
            //        });
            //    }
            //    return sum;
            //},
            //totalTransOutAmount: function () {
            //    var sum = 0;
            //    if (this.arr_CashPositionReportDetailList) {
            //        this.arr_CashPositionReportDetailList.forEach(e => {
            //            sum += e.TO;
            //        });
            //    }
            //    return sum;
            //},
            //totalServiceAmount: function () {
            //    var sum = 0;
            //    if (this.arr_CashPositionReportDetailList) {
            //        this.arr_CashPositionReportDetailList.forEach(e => {
            //            sum += e.SF;
            //        });
            //    }
            //    return sum;
            //},
            //totalDayAmount: function () {
            //    var sum = 0;
            //    sum = this.totalDepositAmount + this.totalTransInAmount - (this.totalWithDrawAmount + this.totalTransOutAmount + this.totalPromoAmount + this.totalServiceAmount);
            //    return sum;
            //}

        },
        created() {
            this.$parent.showSubMenu = "R";
            this.$parent.showSubSubMenu = 'RS2';
            this.$parent.showActiveMenu = "R.CPR";

            this.getCashPositionDetails();
            this.getBankDailyDetails();
            this.getBankName();
            this.agi = this.$route.query.agi;
            this.rDate = this.$route.query.rDate;
            this.button.text = this.getLanguage["CPR"]["SBD"];
            this.setThousandCurrency(false);
        },
        watch: {
            bool_isAMV() {
                if (!this.bool_isAMV && this.bool_CV) {
                    this.showSuccessMessage(this.utilGetErrorLanguage("ERR.SS"), this.utilGetErrorLanguage("GL.AS"));
                }
            }
        },
        methods: {
            ...mapActions('CurrencyInfo', ['setThousandCurrency']),

            renderBank(data) {
                var text = "";
                if ((data != "") && (data != null)) {
                    text = '[' + data + ']';
                }
                return text;
            },
            refreshThisPage() {

                this.getCashPositionDetails();
                this.getBankDailyDetails();
            },
            addRecord() {
                this.obj_ab = {
                    ED: moment(this.rDate).format('DD MMM YYYY'),
                    ET: moment(new Date()).format('HH:mm:ss'),
                    I: 0,
                    CTS: "0001-01-01T00:00:00",
                    CBI: 0,
                    CB: null,
                    UTS: "0001-01-01T00:00:00",
                    UBI: 0,
                    UB: null,
                    AGI: this.agi,
                    TI: 0,
                    TO: 0,
                    SF: 0,
                    R: null,
                    LEDT: null,
                    BN: null,
                    BID: null,
                    BI: null,
                    BA: null,
                    BAN: null,
                    BAID: null
                };
                this.dd_bankacc = [];
                this.arry_type = [];
                this.bool_isAMV = true;
                this.bool_CV = false;
                this.newImg = false;

            },
            getBankName() {
                this.dd_bank = [];
                this.dd_bankacc = [];
                var that = this;
                this.getDataApi(`/api/dd/bank/` + this.str_bankacc_used_agi + "/9",
                    function (d, s) {
                        if (s) {
                            that.dd_bank = d.dropdownlist;
                        }
                    });
            },
            BankNameChange(value) {
                this.dd_bankacc = [];
                this.obj_ab.BAID = null;

                if (value != undefined && this.str_bankacc_used_agi > 0) {
                    var that = this;
                    this.getDataApi(`/api/dd/bankacc/` + value + "/" + this.str_bankacc_used_agi + "/9",
                        function (d, s) {
                            if (s) {
                                that.dd_bankacc = d.dropdownlist;
                            }
                        });
                }
            },
            BankAccountChange(value) {
                this.CurrencySymbol = '';
                if (value) {
                    var bankAccount = this.dd_bankacc.find(obj => {
                        return obj.id == value;
                    });
                    if (bankAccount && bankAccount.CS != '') {
                        this.CurrencySymbol = bankAccount.CS;
                    }
                }
            },
            saveRecord() {
                this.bool_CV = true;
                this.$v.obj_ab.$touch();
                if (!this.$v.obj_ab.$error) {

                    //if (this.obj_ab.TI == 0 && this.obj_ab.TO == 0 && this.obj_ab.SF == 0) {
                    //    this.showErrorIfAll0 = true;
                    //    return;
                    //}

                    this.bool_fullLoading = true;
                    this.obj_ab.LEDT = moment(this.obj_ab.ED).format('YYYY-MM-DD') + " " + this.obj_ab.ET;

                    // var total = parseFloat(this.obj_ab.TI) + parseFloat(this.obj_ab.TO) + parseFloat(this.obj_ab.SF);
                    //if (parseFloat(total) > 0) {
                    //if (this.obj_ab.TI || this.obj_ab.TO || this.obj_ab.SF) {
                    if ((Math.abs(this.obj_ab.TI) != 0) || (Math.abs(this.obj_ab.TO) != 0) || (Math.abs(this.obj_ab.SF) != 0)) {

                        for (var pt of this.dd_bank) {
                            if (pt.id == this.obj_ab.BID) {
                                this.obj_ab['BA'] = pt.label;
                            }
                        }

                        for (var pt of this.dd_bankacc) {
                            if (pt.id == this.obj_ab.BAID) {
                                this.obj_ab['BI'] = this.obj_ab.BAID;
                                this.obj_ab['BAN'] = pt.label;
                            }
                        }
                        var that = this;
                        this.postDataApi('/api/cashposition/scs', this.obj_ab, function (d, s) {                            
                            if (s) {
                                that.bool_isAMV = false;
                                that.getCashPositionDetails();
                                that.getBankDailyDetails();
                            }
                            that.bool_fullLoading = false;
                        });
                    } else {
                        this.bool_fullLoading = false;
                        this.showErrorMessage(null, String.format(this.utilGetErrorLanguage('1011'), this.getLanguage["CPR"]["INVAM"]), 1000);
                    }
                    // }

                }
            },
            reloadParent() {
                window.opener.reloadList();
            },

            checkModuleAccess2(type) {
                return this.checkModuleAccess('CPR', 'R', type);
            },
            checkRequestStatus(status) {
                if (status == 1) {
                    return true;
                }
            },
            closeAdd() {
                this.bool_isAMV = !this.bool_isAMV;
                this.bool_CV = false;
            },
            setSortTable(SV) {
                //SV = Sort Value
                this.int_Page = 1;
                this.int_IC = 1;
                this.str_tableSortBy = SV;
                this.bool_isSort = !this.bool_isSort; //change Ascending or Descending ,and then goto the {watch:/bool_isTAD}
                this.getCashPositionDetails();
                this.getBankDailyDetails();
            },
            ValidationErrMsg(value, langKey = "") {
                if (this.bool_CV) {
                    var validateObj = this.$v.obj_ab[value];
                    if (validateObj.required != undefined && !validateObj.required) {
                        return String.format(this.utilGetErrorLanguage('1001'), this.getLanguage["CPR"][langKey]);
                    } else if (validateObj.decimal != undefined && !validateObj.decimal) {
                        return String.format(this.utilGetErrorLanguage('1009'), this.getLanguage["CPR"][langKey]);
                    }
                }
            },
            getBankDailyDetails() {
                this.bool_fullLoading = true;
                var that = this;
                var path = "";

                if (this.agi != "" || this.agi != null) {
                    path += "&f[AGI]=" + this.agi;
                }
                if (this.rDate != "" || this.rDate != null) {
                    path += "&f[CTS_from]=" + this.rDate;
                }

                this.getDataApi(`/api/cashposition/cpdbs?${path}`,
                    function (d, s) {
                        that.bool_fullLoading = false;
                        if (s) {
                            that.arr_CashPositionBankSummaryList = d.Item1;
                            that.CashPositionBankTotal = d.Item2;
                        }
                    });
            },
            SignOff() {
                this.$fire({
                    title: this.getLanguage["FR"]["SOFF"],//"Sign Off",
                    width: '30em',
                    showCancelButton: true,
                    html: this.getLanguage["FR"]["SFMG"],//"Report cannot be modified after signed off. Please make sure all the amount is finalized before sign off. Are you confirm to sign off this report?",
                    confirmButtonText: this.getLanguage["GL"]["YES"],
                    cancelButtonText: this.getLanguage["CNO"]["NO"],
                    reverseButtons: true,
                    customClass: {
                        title: 'afb-alert-title',
                        content: 'afb-alert-content',
                        actions: 'afb-alert-action'
                    }
                }).then((result) => {

                    if (result.value == true) {
                        this.bool_fullLoading = true;
                        var that = this;
                        var dt = {
                            // i: parseInt(data.TID.substr(3)),
                            // uts: data.TU
                            AGI: this.agi,
                            LD: this.rDate,
                        };

                        this.postDataApi(`/api/cashposition/soff`, dt,
                            function (d, s) {
                                that.bool_fullLoading = false;
                                if (s) {
                                    that.getCashPositionDetails();
                                    that.getBankDailyDetails();
                                    that.showSuccessMessage(that.utilGetErrorLanguage("ERR.SS"), that.utilGetErrorLanguage("GL.AS"));
                                    reloadParent();
                                }
                            });
                    }

                });
            },
            getCashPositionDetails() {

                this.bool_fullLoading = true;
                var that = this;
                var path = this.getListingParamQuery(this.int_Page, this.int_RC, this.str_tableSortBy, this.bool_isSort);

                if (path) {
                    //  if (this.agi && this.rDate) {
                    if (this.agi != "" || this.agi != null) {
                        path += "&f[AGI]=" + this.agi;
                    }
                    if (this.rDate != "" || this.rDate != null) {
                        var cts_from = this.parseDateToJsonString(this.rDate);
                        path += "&f[CTS_from]=" + cts_from;
                    }

                }

                this.getDataApi(`/api/cashposition/cp?${path}`,
                    function (d, s) {
                        that.bool_fullLoading = false;
                        if (s) {                            
                            that.int_TP = Math.max(d.Item2.D.TotalPages, 1);
                            that.int_Total = d.Item2.D.TotalItems;
                            that.arr_CashPositionReportDetailList = d.Item2.D.Items;
                            that.CashPositionReportDetail = d.Item3;
                            if (d.Item1) {
                                that.isSignOff = d.Item1.RS == 2;
                                that.lastSignOffDate = "Signed Off at " + that.formatDateTime(d.Item1.UTS, "YYYY-MM-DD HH:mm:ss", "DD MMM YYYY HH:mm:ss");
                            }
                        }
                    });
            },
            saveToExcel() {
                var path = this.getListingParamQuery(this.int_Page, this.int_RC, this.str_tableSortBy, this.bool_isSort);
                if (path) {
                    //  if (this.agi && this.rDate) {
                    if (this.agi != "" || this.agi != null) {
                        path += "&f[AGI]=" + this.agi;
                    }
                    if (this.rDate != "" || this.rDate != null) {
                        var cts_from = this.parseDateToJsonString(this.rDate);
                        path += "&f[CTS_from]=" + cts_from;
                    }
                    window.open('/api/cashposition/cashpositiondetailexcel?' + path, '_blank');
                }
            },
            removeManualEntries(data) {
                this.$fire({
                    title: this.getLanguage["GL"]["DLTM"],
                    width: '30em',
                    showCancelButton: true,
                    confirmButtonText: this.getLanguage["GL"]["YES"],
                    cancelButtonText: this.getLanguage["GL"]["NO"],
                    reverseButtons: true,
                    customClass: {
                        title: 'afb-alert-title',
                        content: 'afb-alert-content',
                        actions: 'afb-alert-action'
                    }
                }).then((result) => {
                    if (result.value == true) {
                        this.bool_fullLoading = true;
                        var that = this;
                        var dt = {
                            i: parseInt(data.TID.substr(3)),
                            uts: data.TU
                        };

                        this.postDataApi(`/api/cashposition/d`, dt,
                            function (d, s) {
                                that.bool_fullLoading = false;
                                if (s) {
                                    that.getCashPositionDetails();
                                    that.getBankDailyDetails();
                                    that.showSuccessMessage(that.utilGetErrorLanguage("ERR.SS"), that.utilGetErrorLanguage("GL.AS"));
                                }
                            });
                    }
                });
            },
            CountItem(value) {
                if (this.int_IC != 1) {
                    return value + ((this.int_IC - 1) * this.int_RC);
                }
                else {
                    return value;
                }
            },
            ctrPage(newPage,inputValue = 1) {
                if (inputValue == 0) {
                    this.int_Page = Math.max(1, Math.min(newPage, this.int_TP));
                }
                else {
                    this.int_Page = (newPage > this.int_TP) ? 1 : (newPage < 1) ? this.int_TP : newPage;
                }
                this.int_IC = this.int_Page;
                this.getCashPositionDetails();
                this.getBankDailyDetails();
            },
            newSearch() {
                if (!this.bool_isAMV) {
                    this.$refs.search.focus();
                    this.int_Page = 1;
                    this.int_IC = 1;
                    this.getCashPositionDetails();
                    this.getBankDailyDetails();
                }
            },
            ShowDetails() {
                this.bool_showDetails = !this.bool_showDetails;
                this.seen = !this.seen;
                this.button.text = this.seen ? this.getLanguage["CPR"]["HBD"] : this.getLanguage["CPR"]["SBD"];
            },
            formatMonth(date) {
                return moment(date).format('DD/MM');
            },
            formatTime(date) {
                return moment(date).format('HH:mm:ss');
            },
            formatString(data, strLength) {
                return data.substring(0, strLength) + '...';
            },
            formatBankName(BN, BAN) {
                if (BN != null) {
                    return "[" + BN + "]";
                }
                else if (BAN == "H2P") {
                    return "[Easy Pay]";
                }
                return null;
            },
            checkWholeNumber(num) {
                return !!(num % 1);
            },
            checkTransID(whichID, RS) {
                var TF = false;
                if (whichID.substring(0, 2) == "E2") {
                    if (RS != 2) {
                        TF = true;
                    }
                }
                return TF;
            }
        }
    };
</script>

<style scoped>
    .a {
        color: blue !important;
        cursor: pointer;
    }

    .tab-content .tab-pane {
        padding: 15px 0px;
    }

    .text-center {
        text-align: center;
    }

    .text-left {
        text-align: left;
    }

    .text-right {
        text-align: right;
    }

    .text-purple {
        color: #330066;
    }

    .cp-sticky {
        bottom: 0;
        text-align: inherit;
        background-color: #243147 !important;
        position: -webkit-sticky;
        position: sticky;
        z-index: 2;
    }

    .cp-positive {
        color: #20d27c !important;
    }

    .cp-negative {
        color: #ef5565 !important;
    }

    .cp-white {
        font-weight: normal !important;
        color: #FFFFFF !important;
    }

    .isItalic {
        font-style: italic !important;
        font-family: sans-serif !important;
        font-weight: 600 !important;
    }
</style>



// WEBPACK FOOTER //
// src/components/SideMenu/Reports/Page/CPD.vue